import React from 'react';
import { Input } from 'antd';
import type { InputProps } from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

interface InputDOBProps extends Omit<InputProps, 'value' | 'onChange'> {
  value?: string;
  onChange?: (value: string | null) => void;
}

const InputDOB = ({ value, onChange, ...props }: InputDOBProps) => {
  const [inputValue, setInputValue] = React.useState(
    value ? dayjs(value).format('MM/DD/YYYY') : '',
  );

  React.useEffect(() => {
    setInputValue(value ? dayjs(value).format('MM/DD/YYYY') : '');
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const digits = e.target.value.replace(/\D/g, '').slice(0, 8);

    let formatted = digits;

    if (digits.length > 4) {
      formatted = `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
    } else if (digits.length > 2) {
      formatted = `${digits.slice(0, 2)}/${digits.slice(2)}`;
    }

    setInputValue(formatted);

    if (formatted.length === 10) {
      const date = dayjs(formatted, 'MM/DD/YYYY', true);

      onChange?.(
        date.isValid()
          ? `${date.format('YYYY-MM-DD')}T00:00:00.000+00:00`
          : null,
      );
    } else {
      onChange?.(null);
    }
  };

  return (
    <Input
      {...props}
      value={inputValue}
      placeholder='MM/DD/YYYY'
      maxLength={10}
      onChange={handleChange}
      style={{ height: '48px', fontSize: '16px', fontWeight: '500', borderRadius: '4px' }}
    />
  );
};

export default InputDOB;